import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
    DatiqNxRepoStatusProjectKeysRes,
    DatiqNxRepoStatusProjectRes,
    DatiqNxRepoStatusProjectSummaryRes,
    emptyProjectInfo,
    emptyProjectSummary,
    INxStatusProjectService,
    ProjectInfo,
    ProjectQuery,
    ProjectSummary,
    exportCsv,
    ProjectUpdateInfo,
} from '@dat/datiq-nx-repo-utils';
import { lastValueFrom, map } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DatiqNxRepoClientApiService implements INxStatusProjectService {
    private _http: HttpClient = inject(HttpClient);
    constructor() {}
    async exportProject(
        fileType: string,
        query: ProjectQuery,
    ): Promise<string> {
        const response: string = await lastValueFrom(
            this._http.put(
                this.getUrl(`projects/export?fileType=${fileType}`),
                query,
                {
                    responseType: 'text',
                },
            ),
        );

        exportCsv(response, query);

        return response;
    }

    async getProjectSummary(query: ProjectQuery): Promise<ProjectSummary> {
        const response: DatiqNxRepoStatusProjectSummaryRes =
            await lastValueFrom(
                this._http.put<DatiqNxRepoStatusProjectSummaryRes>(
                    this.getUrl(`projects/summary`),
                    query,
                ),
            );

        return {
            ...emptyProjectSummary,
            ...(response?.summary ?? {}),
        };
    }

    async getProjects(): Promise<Record<string, ProjectInfo>> {
        return {};
    }
    async queryProjectKeys(query: ProjectQuery): Promise<string[]> {
        const response: DatiqNxRepoStatusProjectKeysRes = await lastValueFrom(
            this._http.put<DatiqNxRepoStatusProjectKeysRes>(
                this.getUrl(`projects/summary/keys`),
                query,
            ),
        );

        return response.keys;
    }
    async getProject(project: string): Promise<ProjectInfo> {
        const response: DatiqNxRepoStatusProjectRes = await lastValueFrom(
            this._http.get<DatiqNxRepoStatusProjectRes>(
                this.getUrl(`projects/${project}`),
            ),
        );

        return {
            ...emptyProjectInfo,
            ...response.project,
        };
    }

    async queryProjects(query: ProjectQuery): Promise<ProjectInfo[]> {
        const response: ProjectInfo[] = await lastValueFrom(
            this._http.put<ProjectInfo[]>(this.getUrl(`projects`), query),
        );

        return response;
    }

    async updateProject(
        projectKey: string,
        projectInfo: Partial<ProjectUpdateInfo>,
    ): Promise<ProjectInfo> {
        const response: ProjectInfo = await lastValueFrom(
            this._http.put<ProjectInfo>(this.getUrl(`projects/${projectKey}`), {
                ...projectInfo,
            }),
        );

        return response;
    }

    getUrl(path: string): string {
        return `http://localhost:3000/nx-tools/v1/status/${path}`;
    }
}
